module.exports = __webpack_public_path__ + "static/media/bscpad.73e11c2a.webp";